// Generated by ts-to-zod
import { z } from 'zod';

export const deleteRecommendationListQueryEncoderSchema = z.object({
  queue: z.number().optional(),
});
